import React from 'react';
import { useState } from 'react';

import Overview from './components/Panels/Overview';
import InstitutionalClassification from './components/Panels/InstitutionalClassification';
import StudentAccessAndEarnings from './components/Panels/StudentAccessAndEarnings';
import ResearchActivityDesignation from './components/Panels/ResearchActivityDesignation';

// This is just me playing around with tabs.
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import Container from 'react-bootstrap/Container';

import Cookies from 'js-cookie';

export function Profile() {

    const institutionData = getInstitutionData() || {};
    console.log("Institution Data: ", institutionData);

    // toggle lines below to remember what tab you were on between refreshes
    // (helpful for developing) 
    //const [key, setKey] = useState(Cookies.get("currentTab") ?? 'overview');
    const [key, setKey] = useState('overview');

    const sae = institutionData.post_meta.saec2025.value > 0;
    const rad = institutionData.post_meta.research2025.value > 0;

    function updateTab(key) {
        Cookies.set("currentTab", key);
        setKey(key);
    }

    return (
        <div style={{ backgroundColor: "#F5F8FA" }}>
            <Tab.Container id="profile-tabs" defaultActiveKey={key} activeKey={key} onSelect={(k) => { updateTab(k) }} transition={false}>
                <div className='border-bottom background-white'>
                    <div className="container">
                        <div id="faq-navbar" className="carnegie-subnav container flex-column">
                            <Nav className='flex-column flex-lg-row'>
                                <Nav.Item className={key == 'overview' ? 'current-menu-item' : ""}>
                                    <Nav.Link eventKey="overview">Overview</Nav.Link>
                                </Nav.Item>
                                <Nav.Item className={key == 'institutional' ? 'current-menu-item' : ""}>
                                    <Nav.Link eventKey="institutional">Institutional Classification</Nav.Link>
                                </Nav.Item>
                                {sae &&
                                    <Nav.Item className={key == 'sae' ? 'current-menu-item' : ""}>
                                        <Nav.Link eventKey="sae">Student Access and Earnings Classification</Nav.Link>
                                    </Nav.Item>
                                }
                                {rad &&
                                    <Nav.Item className={key == 'research' ? 'current-menu-item' : ""}>
                                        <Nav.Link eventKey="research">Research Activity Designation</Nav.Link>
                                    </Nav.Item>
                                }
                            </Nav>
                        </div>
                    </div>
                </div>

                <Container className="py-3">
                    <Tab.Content>
                        <Tab.Pane eventKey="overview">
                            <Overview institutionData={institutionData} updateTab={updateTab} />
                        </Tab.Pane>
                        <Tab.Pane eventKey="institutional">
                            <InstitutionalClassification institutionData={institutionData} />
                        </Tab.Pane>
                        {sae &&
                            <Tab.Pane eventKey="sae">
                                <StudentAccessAndEarnings institutionData={institutionData} />
                            </Tab.Pane>
                        }
                        {rad &&
                            <Tab.Pane eventKey="research">
                                <ResearchActivityDesignation institutionData={institutionData} />
                            </Tab.Pane>
                        }
                    </Tab.Content>
                </Container>
            </Tab.Container >
        </div>
    );
}


function getInstitutionData() {
    // Not sure if it's better to pull this data in here or have it in the App component proper.
    const rawData = window.ace_carnegie_institution_data || {};

    return rawData.hasOwnProperty('data') ? rawData.data : {};
}